// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__12fyO","homeImgBackground":"hero_homeImgBackground__VY8ZI"};